import { sendRequest, sendGoogleEvent } from '@html/_common/utils';

import AMAlternativeItineraries from '@atomic/molecules/tour_b/alternative-itineraries';
import AOTourRateTranslation from '@atomic/organisms/_common/rate-translation';

export default class AOItinerary {
  constructor(tourId, tourName, tdpEventCategory) {
    this.tourId = tourId;
    this.tourName = tourName;
    this.TDP_EVENT_CATEGORY = tdpEventCategory;
    this.itineraryListSelector = '.js-ao-tour-itinerary__list';
    this.pointsSelector = '.js-ao-tour-itinerary__point';
    this.itineraryState = 'translated';
    this.itineraryContentWrapperClass = 'ao-tour-itinerary__content-wrapper';
    this.itineraryAccommodationWrapper = 'ao-tour-itinerary__accommodation-wrapper';
    this.itinerary = {
      original: null,
      translated: null,
    };
    this.notClose = false;
  }

  initiate() {
    this.initiateClicks();
    const alternativeItineraries = new AMAlternativeItineraries(
      this.common,
      this.tourId,
      this.tourName,
      this.TDP_EVENT_CATEGORY,
    );
    alternativeItineraries.initiate();
  }

  /* header clicks */
  initiateClicks() {
    $('.js-ao-tour-itinerary > ol > li').click((e) => {
      if ($(e.target).parents('.i').length > 0) {
        return;
      }

      const $clickedElement = $(e.currentTarget);
      if ($clickedElement.hasClass('active')) {
        if (this.notClose) {
          this.notClose = false;
        } else {
          $clickedElement.removeClass('active');
        }
      } else {
        if (!$clickedElement.hasClass('initiated')) {
          $clickedElement.find('.js-ao-scout-accordion__arrow').addClass('invis');
          $clickedElement
            .addClass('initiated')
            .append('<div class="ao-scout-accordion__loader scout-loader-three-dots"><span class="scout-loader-three-dots__loader"></span></div>');
        }

        this.load(this.itineraryState, () => {
          $clickedElement.addClass('active');
          $clickedElement.find('.ao-scout-accordion__loader').remove();
          $clickedElement.find('.js-ao-scout-accordion__arrow').removeClass('invis');
        });
      }

      /* Check if user manually closes/opens all items */
      const $itnList = $('.js-ao-tour-itinerary__list');
      const $expandAll = $('.js-ao-tour-itinerary .ex');
      if ($itnList.find('.active').length === 0) {
        $expandAll.text($('.js-ao-tour-itinerary').data('expand-text'));
      } else if ($itnList.find('.active').length === $itnList.children('li').length) {
        $expandAll.text($('.js-ao-tour-itinerary').data('hide-text'));
      }
    });

    const rateTranslation = new AOTourRateTranslation(this.common, $('.js-ao-tour-itinerary'));
    rateTranslation.initiate();

    import(/* webpackChunkName: "AOScoutAccordion" */'@scout/components/accordion/accordion').then((module) => {
      const AOScoutAccordion = module.default;
      const accordion = new AOScoutAccordion({
        selector: '.js-ao-tour-itinerary',
        onExpand: () => {
          sendGoogleEvent(
            this.TDP_EVENT_CATEGORY,
            'Itinerary',
            'Expand - One',
            {
              ampEventName: 'tdp_itinerary_clicked',
              tdp_itinerary_clicked_element: 'Day Expanded',
            },
          );
        },
        onCollapse: () => {
          sendGoogleEvent(
            this.TDP_EVENT_CATEGORY,
            'Itinerary',
            'Collapse - One',
            {
              ampEventName: 'tdp_itinerary_clicked',
              tdp_itinerary_clicked_element: 'Collapse Day',
            },
          );
        },
      });
      accordion.initiate();

      $('.js-ao-tour-itinerary .ex').click((event) => {
        const $listOfAccordions = $('.js-ao-tour-itinerary>ol>li');

        const $clickedElement = $(event.currentTarget);
        const isCurrentlyExpanded = $clickedElement.text() === $('.js-ao-tour-itinerary').data('expand-text');
        if (isCurrentlyExpanded) {
          $clickedElement.text($('.js-ao-tour-itinerary').data('hide-text'));
          accordion.accordions.toggleMultipleAccordions($listOfAccordions, 'expand');

          $('.js-ao-tour-itinerary>ol>li:not(.initiated)')
            .addClass('initiated')
            .append('<span class="ao-scout-accordion__loader"></span>');

          this.load(this.itineraryState, () => {
            $('.js-ao-tour-itinerary>ol>li')
              .addClass('active')
              .find('.ao-scout-accordion__loader').remove();
          });

          sendGoogleEvent(
            this.TDP_EVENT_CATEGORY,
            'Itinerary',
            'Expand - All',
            {
              ampEventName: 'tdp_itinerary_clicked',
              tdp_itinerary_clicked_element: 'Expand All',
            },
          );
        } else {
          $clickedElement.text($('.js-ao-tour-itinerary').data('expand-text'));
          accordion.accordions.toggleMultipleAccordions($listOfAccordions, 'collapse');
          $('.js-ao-tour-itinerary>ol>li').removeClass('active');

          sendGoogleEvent(
            this.TDP_EVENT_CATEGORY,
            'Itinerary',
            'Collapse - All',
            {
              ampEventName: 'tdp_itinerary_clicked',
              tdp_itinerary_clicked_element: 'Collapse All',
            },
          );
        }
      });

      $('.js-ao-tour-itinerary .translate-link').click((event) => {
        const link = $(event.currentTarget);
        if (link.parent('.translated-block').hasClass('original')) {
          this.load('translated', () => {
            $('.js-ao-tour-itinerary .translated-block.translated').removeClass('hid');
            $('.js-ao-tour-itinerary .translated-block.original').addClass('hid');
          });

          sendGoogleEvent(
            this.TDP_EVENT_CATEGORY,
            'Itinerary',
            'Translate',
          );
        } else {
          this.load('original', () => {
            $('.js-ao-tour-itinerary .translated-block.translated').addClass('hid');
            $('.js-ao-tour-itinerary .translated-block.original').removeClass('hid');
          });

          sendGoogleEvent(
            this.TDP_EVENT_CATEGORY,
            'Itinerary',
            'Show original',
          );
        }
      });
    });
  }

  /* load itineraries */
  load(itineraryState, callback) {
    const refreshItinerary = (this.itineraryState !== itineraryState);
    this.itineraryState = itineraryState;
    if (this.itinerary[itineraryState] === null) {
      this.itinerary[itineraryState] = {};
      $('body').addClass('wait');

      let url = `/api/tour/itinerary/${this.tourId}`;
      if (itineraryState === 'original') {
        url += '?original=1';
      }
      sendRequest(url, {}, (data) => {
        $('body').removeClass('wait');

        if (data && data.success === true) {
          this.itinerary[this.itineraryState] = data;
          this.fillItinerary(data);
        }

        setTimeout(() => {
          callback();
        }, 10);
      }, { type: 'GET' });
    } else {
      if (refreshItinerary) {
        this.fillItinerary(this.itinerary[this.itineraryState]);
      }

      callback();
    }
  }

  fillItinerary(data) {
    const {
      accommodationTitle,
      upgradeAvailable,
      accommodationSubtitle,
    } = document.querySelector(this.itineraryListSelector).dataset;
    if (data.description.length > 0) {
      $(`.js-ao-tour-itinerary > ol:not(${this.itineraryListSelector}) li .i`).remove();
      $(`.js-ao-tour-itinerary > ol:not(${this.itineraryListSelector}) li`).find('.js-ao-scout-accordion__bottom-content').append(`<div class="i ${this.itineraryContentWrapperClass}">${data.description}</div>`);
    }
    for (let i = 0; i < data.itinerary.length; i += 1) {
      const blockSelector = `.js-ao-tour-itinerary ${this.itineraryListSelector} > li:nth-child(${i + 1})`;
      $(`${blockSelector} .${this.itineraryContentWrapperClass}`).remove();
      $(blockSelector).find('.js-ao-scout-accordion__bottom-content').append(`<div class="i ${this.itineraryContentWrapperClass}"></div>`);
      $(`${blockSelector} .${this.itineraryContentWrapperClass}`).append(`
        <div class="ao-scout-accordion__bottom-content-itinerary js-ao-scout-accordion__bottom-content-itinerary">
            ${data.itinerary[i].description}
        </div>
      `);

      if (data.itinerary[i].point) {
        $(`${blockSelector} .${this.itineraryContentWrapperClass}`).append(`
          <div class="${this.pointsSelector}">${data.itinerary[i].point.component}</div>
        `);
      }

      const accommodations = data.itinerary[i].accommodations || [];

      if (accommodations.length > 0) {
        $(`${blockSelector} .${this.itineraryContentWrapperClass}`).append(`
        <div class="ao-tour-itinerary__accommodation-title" data-cy="tdp-itinerary--accommodation-title">
            ${accommodationTitle}
        </div>`);

        if (accommodations.length > 1) {
          $(`${blockSelector} .${this.itineraryContentWrapperClass}`).append(`
          <div class="ao-tour-itinerary__accommodation-subTitle" data-cy="tdp-itinerary--accommodation-sub-title">
              ${accommodationSubtitle}:
          </div>

        `);
        }
        $(`${blockSelector} .${this.itineraryContentWrapperClass}`).append(`
        <div class="${this.itineraryAccommodationWrapper} js-${this.itineraryAccommodationWrapper}"></div>
      `);

        accommodations.forEach((accommodation) => {
          $(`${blockSelector} .${this.itineraryContentWrapperClass} .js-${this.itineraryAccommodationWrapper}`).append(`
          <div class="ao-tour-itinerary__accommodation-content" data-cy="tdp-itinerary--accommodation-block">
            <div class="ao-tour-itinerary__accommodation-content-title" data-cy="tdp-itinerary--accommodation-name">${accommodation.title || ''}</div>
            <div class="ao-tour-itinerary__accommodation-content-details">
              <div class="ao-tour-itinerary__accommodation-content-type ao-tour-where-stay__title-image ao-tour-where-stay__title-image--${accommodation.accommodation_type_id}" data-cy="tdp-itinerary--accommodation-type">${accommodation.accommodation_type_name || ''}</div>
              ${accommodation.rating ? `
                  <div class="am-tour-reviews__rating-stars-block" data-cy="tdp-itinerary--accommodation-stars">
                    ${Array.from(Array(accommodation.rating)).map(() => '<div class="ao-tour-itinerary__accommodation-content-star"></div>').join('')}
                  </div>
              ` : ''}
            </div>
            ${accommodation.has_upgrade_available ? `<div class="ao-tour-itinerary__accommodation-content-upgrade-available" data-cy="tdp-itinerary--accommodation-upgrade">${upgradeAvailable}</div>` : ''}
          </div>
        `);
        });
      }
    }

    this.initGallery(data.itinerary);
  }

  initGallery(itinerary) {
    for (let i = 0; i < itinerary.length; i += 1) {
      const blockSelector = `.js-ao-tour-itinerary ${this.itineraryListSelector} > li:nth-child(${i + 1})`;
      const citiesListText = $('.js-ao-tour-itinerary').data('cities-text');
      const $imageBlock = $(`${blockSelector} .${this.itineraryContentWrapperClass} .im`);

      if (itinerary[i].city_images.length > 0) {
        $.each(itinerary[i].city_images, (photoIds, photos) => {
          $.each(photos, (photoId, photo) => {
            let first = false;
            const $hideImageButton = $('.js-ao-tour-itinerary .hide-img-block');
            const id = photo.id || 0;

            if ($(`${blockSelector} .im`).length === 0) {
              first = true;
              $(`${blockSelector} .${this.itineraryContentWrapperClass} .js-ao-scout-accordion__bottom-content-itinerary`).prepend('<div class="im"></div>');

              if ($hideImageButton.length) {
                $hideImageButton.clone().eq(0).appendTo(`${blockSelector} .${this.itineraryContentWrapperClass} .im`).removeClass('hid');
              }
            }

            let newImg;
            if (first) {
              newImg = $(`${blockSelector} .${this.itineraryContentWrapperClass} .im`).append(`<div style="background-image:url(${photo.url_tr})" data-id="${id}" class="l show"></div>`);
            } else {
              newImg = $(`${blockSelector} .${this.itineraryContentWrapperClass} .im`).append(`<div data-bg="background-image:url(${photo.url_tr})" data-id="${id}" class="l"></div>`);
            }

            if (id) {
              $(':last-child', newImg).data('id', id);
            }
          });
        });

        $imageBlock.append(`<div class="ann">${citiesListText.replace('{{citiesList}}', Object.values(itinerary[i].city_names).join(', '))}</div>`);
      }

      const photoCount = $(`${blockSelector} .${this.itineraryContentWrapperClass} .im .l`).length;

      if (photoCount > 1) {
        $(`${blockSelector} .${this.itineraryContentWrapperClass} .im`).prepend('<div class="arrow right"></div><div class="arrow left"></div>');
      }
    }

    $(`.js-ao-tour-itinerary ${this.itineraryListSelector} .im .hide-img-block`).click((event) => {
      const $clickedElement = $(event.currentTarget);
      if (!$clickedElement.siblings('.show').data('id')) {
        window.alert("Can't hide this image."); // eslint-disable-line no-alert
      }
      const $imageBlock = $clickedElement.parent();
      const $current = $imageBlock.find('.show');

      sendRequest(
        '/api/tour/admin-hide-image',
        { id: $current.data('id') },
        (response) => {
          if (response && response.status === 'OK') {
            $current.remove();
            $imageBlock.find('.l').first().addClass('show');
          } else if (response && response.status === 'error' && response.message) {
            window.alert(response.message); // eslint-disable-line no-alert
          }
        },
      );
    });

    $(`.js-ao-tour-itinerary ${this.itineraryListSelector} .im .right`).click((event) => {
      const $clickedElement = $(event.currentTarget);
      this.notClose = true;
      const total = $clickedElement.parent().find('.l').length;
      const current = $clickedElement.parent().find('.l.show').index();

      let next;
      if ($clickedElement.parent().find('.hide-img-block').length > 0) { // If user is admin
        next = (current - 1 <= total) ? current + 2 : 4;
      } else {
        next = (current > total) ? 3 : current + 2;
      }

      $clickedElement.parent().find('.l').removeClass('show');
      if ($clickedElement.parent().find(`.l:nth-child(${next})`).data('bg')) {
        $clickedElement.parent().find(`.l:nth-child(${next})`).attr('style', $clickedElement.parent().find(`.l:nth-child(${next})`).data('bg'))
          .data('bg', '');
      }
      $clickedElement.parent().find(`.l:nth-child(${next})`).addClass('show');

      sendGoogleEvent(
        this.TDP_EVENT_CATEGORY,
        'Images',
        'Next',
        {
          ampEventName: 'tdp_itinerary_image_clicked',
          tdp_itinerary_image_clicked_direction: 'Next',
        },
      );
    });

    $(`.js-ao-tour-itinerary ${this.itineraryListSelector} .im .left`).click((event) => {
      const $clickedElement = $(event.currentTarget);
      this.notClose = true;
      const total = $clickedElement.parent().find('.l').length;
      const current = $clickedElement.parent().find('.show').index();

      let next;
      if ($clickedElement.parent().find('.hide-img-block').length > 0) { // If user is admin
        next = current < 4 ? total + 3 : current;
      } else {
        next = current < 3 ? total + 2 : current;
      }

      $clickedElement.parent().find('.l').removeClass('show');
      if ($clickedElement.parent().find(`.l:nth-child(${next})`).data('bg')) {
        $clickedElement.parent().find(`.l:nth-child(${next})`).attr('style', $clickedElement.parent().find(`.l:nth-child(${next})`).data('bg'))
          .data('bg', '');
      }
      $clickedElement.parent().find(`.l:nth-child(${next})`).addClass('show');

      sendGoogleEvent(
        this.TDP_EVENT_CATEGORY,
        'Images',
        'Previous',
        {
          ampEventName: 'tdp_itinerary_image_clicked',
          tdp_itinerary_image_clicked_direction: 'Previous',
        },
      );
    });
  }
}
